import { Component } from "@angular/core";
import {
  NavController,
  NavParams,
  MenuController,
  Events,
  Platform,
  AlertController
} from "ionic-angular";
import { TranslateService } from "ng2-translate";
import { EmployeeData } from "../../providers/employee-data";

import { ProjectData } from "../../providers/project-data";
import { Login } from "../../providers/login";

@Component({
  selector: "page-login",
  templateUrl: "login.html",
})
export class LoginPage {
  username: string;
  password: string;
  errorMessage: string;

  constructor(
    private platform: Platform,
    private events: Events,
    private alertCtrl: AlertController,
    private translate: TranslateService,
    public navCtrl: NavController,
    public navParams: NavParams,
    public menuCtrl: MenuController,
    public projectData: ProjectData,
    private employeeData: EmployeeData,
    public loginProvider: Login,
  ) {
    menuCtrl.enable(false);
    this.errorMessage = navParams.get("errorMessage");
    if (this.errorMessage && this.errorMessage.indexOf("Update de app") > -1) {
      if (this.platform.is("ios")) {
        this.errorMessage += " Tik hier om de update op te halen."; //"Tik hier om testFlight te openen.";
      }
      if (this.platform.is("android")) {
        this.errorMessage += " Tik hier om de update op te halen."; //" Tik hier om de Android update op te halen.";
      }
    }
  }

  onLogin() {
    this.events.publish("login", this.username, this.password);
  }

  onResetLogin() {
    let alert = this.alertCtrl.create({
      title: 'Wachtwoord vergeten',
      subTitle: 'Vul je e-mailadres in en klik op OK. Je krijgt dan een e-mail met verdere instructies.',
      cssClass: 'tv-delete-alert',
      inputs: [{
        name: 'email',
        placeholder: 'E-mail'
      }],
      buttons: [{
        text: this.translate.instant('CANCEL')
      },
      {
        text: this.translate.instant('OK'),
        handler: data => {
          if (data.email) {
            this.employeeData.resetLogin(data.email).then((success) => {
              if (success) {
                this.onResetSuccess();
              }
            });
          }
        }
      }]
    });
    alert.present();
  }

  onResetSuccess() {
    let alert = this.alertCtrl.create({
      title: 'Email verstuurd',
      subTitle: 'Er is een e-mail met verdere instructies verstuurd. Let op! deze bevat een link die 15 minuten geldig is. Controleer dus direct je e-mail.',
      cssClass: 'tv-delete-alert',
      buttons: [{
        text: this.translate.instant('OK')
      }]
    });
    alert.present();
  }

  openError() {
    if (this.errorMessage && this.errorMessage.indexOf("Update de app") > -1) {
      if (this.platform.is("ios")) {
        let url =
          "https://itunes.apple.com/nl/app/top-totaal-app/id1391508004?l=nl&ls=1&mt=8"; //'https://itunes.apple.com/nl/app/testflight/id899247664?mt=8';
        let newWin = window.open(url, "_system");
        if (!newWin) {
          window.location.href = url;
        }
      }
      if (this.platform.is("android")) {
        let url =
          "https://play.google.com/store/apps/details?id=nl.toptotaal.app"; //'https://app.toptotaal.nl/android/android-release.apk';
        let newWin = window.open(url, "_system");
        if (!newWin) {
          window.location.href = url;
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts